// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeAwardCustomRestoreBody = {
  poolId: string;
  awardTypeId: string;
};

export type typeAwardCustomRestoreOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | { awardTypeId: string; status: "active" };
};

export type typeAwardCustomRestoreOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeAwardCustomRestoreOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeAwardCustomRestoreOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaAwardCustomRestoreBody = {
  type: "object",
  properties: {
    poolId: { type: "string", maxLength: 3000, minLength: 1 },
    awardTypeId: { type: "string", maxLength: 3000, minLength: 1 },
  },
  required: ["poolId", "awardTypeId"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createAwardCustomRestore(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaAwardCustomRestoreBody);
  }

  return async function postAwardCustomRestore(
    payload: typeAwardCustomRestoreBody,
  ): Promise<
    typeAwardCustomRestoreOutput200 | typeAwardCustomRestoreOutput400
  > {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postAwardCustomRestore" failed before calling the network. #76bef6ec4d51`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#76bef6ec4d51" },
        },
        data: null,
      } as typeAwardCustomRestoreOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/award/custom-restore`,
      httpMethod: "POST",
      options,
    })) as typeAwardCustomRestoreOutput200 | typeAwardCustomRestoreOutput400;
  };
}
